<div class="box-management">
  <div class="title-box">
    <i class="app-icon-car" style="margin-right: 8px; font-size: 24px;"></i>
    <span>+RaioX (Histórico veicular)</span>
  </div>
  <div class="dossier-text">
    <ng-container *ngIf="!dossierStatus">
      Tenha acesso às informações completas deste veículo, como restrições, impedimentos, indícios de sinistro, riscos
      comerciais e muitas outras.

      <div class="dossier-info-box">
        Feita por uma equipe especializada, a consulta leva apenas 5 minutos em horário comercial!
      </div>
    </ng-container>
    <ng-container *ngIf="dossierStatus === 'COMPLETE'">
      O histórico do veículo <strong translate="no">{{numberPlate}}</strong> foi adicionado e está disponível.
      <small>Última atualização em {{lastUpdated | date: 'dd/MM/yyyy'}} às {{lastUpdated | date: 'HH:mm'}}</small>

    </ng-container>
    <ng-container *ngIf="dossierStatus === 'INCOMPLETE'">
      Aguarde, o histórico veicular ficará pronto em poucos minutos.
      <small>Solicitado em {{lastUpdated | date: 'dd/MM/yyyy'}} às {{lastUpdated | date: 'HH:mm'}}</small>

    </ng-container>

  </div>
  <ng-container *ngIf="!dossierStatus">
    <button class="btn btn-branded5 btn-rounded btn-block" (click)="buyFullDossier()" [disabled]="loading"
      [ngClass]="{loading: loading}">
      <div class="btn-spinner float-left" *ngIf="loading"></div>
      Acesse por apenas <span translate="no">R$ {{dossierPrice | number: '1.2-2'}}</span>
    </button>
    <div class="dossier-text" style="text-align: center; margin-bottom: 0;">
      <small>Valor para a consulta desse veículo</small>
    </div>
  </ng-container>

  <a pageScroll class="btn btn-branded5 btn-rounded btn-block" pageScrollOffset="120" href="#fulldossier"
    [ngClass]="{'disabled': dossierStatus === 'INCOMPLETE'}" *ngIf="dossierStatus">
    Acessar +RaioX (Histórico veicular)
  </a>

  <div class="col-12" *ngIf="dossierStatus">
    <button class="btn btn-link btn-block" [ngClass]="{'disabled': dossierStatus === 'INCOMPLETE'}" (click)="openRepurchaseDossierModal()">
      Atualizar +RaioX
    </button>
  </div>
</div>

<div class="modal-backdrop fade in" [style.display]="showRepurchaseDossier ? 'block' : 'none'"></div>
<div class="modal fade" [ngClass]="{ show: showRepurchaseDossier, hide: !showRepurchaseDossier }"
  [style.display]="showRepurchaseDossier ? 'block' : 'none'" (click)="closeRepurchaseDossierModal()">
  <div class="modal-dialog modal-dialog-centered" (click)="(false); $event.stopPropagation()">
    <div class="modal-content box-arrematar">
      <div class="modal-header">
        <h5 class="title-box">
          Deseja atualizar o +RaioX (Histórico veicular)?
        </h5>
        <button type="button" class="close" data-dismiss="modal" (click)="closeRepurchaseDossierModal()">
          <i class="material-icons notranslate" translate="no">close</i>
        </button>
      </div>
      <div class="modal-body text-center">
        Ao confirmar, será cobrado novamente <br>o valor de <span translate="no">R$ {{dossierPrice | number: '1.2-2'}}</span>.
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-12 text-center">
            <button class="btn btn-primary btn-rounded" (click)="repurchaseDossier()">
              CONFIRMAR
            </button>
          </div>
          <div class="col-12 text-center">
            <button class="btn btn-link" style="margin-top: 8px; color:#0e6c5d" (click)="closeRepurchaseDossierModal()">
              Cancelar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
